import React from "react";
import Field from "./Field";
import CheckboxControl from "./CheckboxControl";
import { FieldProps } from "./Types";

const CheckboxField: React.FC<FieldProps> = ({ labelProps, controlProps, visible, disabled }) => {

    if (visible === false)
        return <></>;

    return (
        <Field {...labelProps}>
            <CheckboxControl {...controlProps} disabled={disabled} />
        </Field>
    );
}
export default CheckboxField;